export const EXCMAGREEMENT_SHOW_RESET = 'EXCMAGREEMENT_SHOW_RESET'
export const EXCMAGREEMENT_SHOW_SET_ERROR = 'EXCMAGREEMENT_SHOW_SET_ERROR'
export const EXCMAGREEMENT_SHOW_SET_RETRIEVED = 'EXCMAGREEMENT_SHOW_SET_RETRIEVED'
export const EXCMAGREEMENT_SHOW_TOGGLE_LOADING = 'EXCMAGREEMENT_SHOW_TOGGLE_LOADING'
